import { useEffect } from 'react';

const AuthInterceptor = () => {
  useEffect(() => {
    // Intercept fetch requests to add auth token
    const originalFetch = window.fetch;
    
    window.fetch = async function(...args) {
      const [url, options = {}] = args;
      
      // Skip for auth endpoints and public routes
      const isAuthEndpoint = url.includes('/api/auth');
      const isPublicRoute = url.includes('/signin') || url.includes('/create-user');
      
      if (!isAuthEndpoint && !isPublicRoute) {
        const token = localStorage.getItem('authToken');
        
        if (token) {
          options.headers = {
            ...options.headers,
            'Authorization': `Bearer ${token}`,
          };
        }
      }
      
      const response = await originalFetch(url, options);
      
      // Handle 401 Unauthorized responses
      if (response.status === 401 && !isPublicRoute) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('authUser');
        // Use window.location instead of navigate
        if (!window.location.pathname.includes('/signin')) {
          window.location.href = '/signin';
        }
      }
      
      return response;
    };

    return () => {
      window.fetch = originalFetch;
    };
  }, []); // Removed navigate dependency

  return null;
};

export default AuthInterceptor;